// utils/groupFields.ts
import { BuilderField, SectionGroup, FieldRowGroup } from '../types/BuilderField';

/**
 * Group by Category -> Group by OrderNo -> rows.
 * The only layout logic in the entire library. No width is ever stored —
 * it's derived every time from how many fields share an orderNo.
 */
export function groupFields(fields: BuilderField[]): SectionGroup[] {
  const byCategory = new Map<string, BuilderField[]>();

  for (const field of fields) {
    if (!byCategory.has(field.category)) byCategory.set(field.category, []);
    byCategory.get(field.category)!.push(field);
  }

  const sections: SectionGroup[] = [];

  for (const [category, categoryFields] of byCategory) {
    const byOrder = new Map<number, BuilderField[]>();
    for (const field of categoryFields) {
      if (!byOrder.has(field.orderNo)) byOrder.set(field.orderNo, []);
      byOrder.get(field.orderNo)!.push(field);
    }

    const rows: FieldRowGroup[] = Array.from(byOrder.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([orderNo, rowFields]) => ({ orderNo, fields: rowFields }));

    sections.push({ category, rows });
  }

  return sections;
}